import * as crypto from 'crypto-browserify'

const CRYPTO_FORMAT = 'aes-256-cbc'
const CRYPTO_CODE_FORMAT = 'utf8'
const CRYPTO_STRING_BASE = 'hex'

/* eslint-disable jsdoc/require-jsdoc */
export function reverseStringValue(value: string): string {
  return value.split('').reverse().join('')
}

export function createCryptoValues(totalBytes: number): string {
  return crypto.randomBytes(totalBytes)
}

// Function to encrypt data
export function encryptData(data: string): string {
  // Generate a random Initialization Vector (IV) of 16 bytes
  const iv = crypto.randomBytes(16)
  const secretKey = crypto.randomBytes(32)

  // Create an AES cipher instance using the key and IV
  const cipher = crypto.createCipheriv(CRYPTO_FORMAT, secretKey, iv)

  // Encrypt the data
  let encrypted: string = cipher.update(
    data,
    CRYPTO_CODE_FORMAT,
    CRYPTO_STRING_BASE
  )
  encrypted += cipher.final(CRYPTO_STRING_BASE)

  const ivString: string = iv.toString(CRYPTO_STRING_BASE)
  const secretKeyString: string = secretKey.toString(CRYPTO_STRING_BASE)

  const ivReversed = reverseStringValue(ivString)
  const secretKeyReversed = reverseStringValue(secretKeyString)
  const encryptedReversed = reverseStringValue(encrypted)

  return `${ivReversed}${encryptedReversed}${secretKeyReversed}`
}

interface TDecryptBaseValues {
  encryptedDataValue: string
  iv: { buffer: Buffer; value: string }
  key: { buffer: Buffer; value: string }
}
export function getDecryptBaseValues(
  encryptedData: string
): TDecryptBaseValues {
  const ivReversed = encryptedData.slice(0, 32)
  const secretReversed = encryptedData.slice(-64)
  const encryptedReversed = encryptedData.slice(32, -64)

  const iv = reverseStringValue(ivReversed)
  const key = reverseStringValue(secretReversed)
  const encryptedDataValue = reverseStringValue(encryptedReversed)

  const ivBuffer = Buffer.from(iv, CRYPTO_STRING_BASE)
  const keyBuffer = Buffer.from(key, CRYPTO_STRING_BASE)

  return {
    encryptedDataValue,
    iv: { buffer: ivBuffer, value: iv },
    key: { buffer: keyBuffer, value: key },
  }
}

export function decryptData(encryptedData: string): string {
  const { encryptedDataValue, iv, key } = getDecryptBaseValues(encryptedData)

  const decipher = crypto.createDecipheriv(CRYPTO_FORMAT, key.buffer, iv.buffer)

  let decrypted = decipher.update(
    encryptedDataValue,
    CRYPTO_STRING_BASE,
    CRYPTO_CODE_FORMAT
  )
  decrypted += decipher.final(CRYPTO_CODE_FORMAT)

  return decrypted
}
